import React from "react";

import momentjs from "moment";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import useMediaQuery from "Hooks/useMediaQuery";
import { formatAsCurrency } from "Libs/utils";

import {
  ContainerSS,
  OrderStatusSS,
  OrderIdSS,
  OrderPeriodSS,
  OrderTotalSS,
  OrderTotalLabelSS,
  ViewLinkSS
} from "./OrderItem.styles";

const formatDate = date => momentjs(date).format("D MMM, YYYY");
const month = date => momentjs(date).format("MMM");
const longPeriod = (start, end) => formatDate(start) + " - " + formatDate(end);

const OrderItem = ({ order }) => {
  const intl = useIntl();
  const date = useMediaQuery("(min-width: 32rem)")
    ? longPeriod(order.billing_period_start, order.billing_period_end)
    : month(order.billing_period_start);

  return (
    <ContainerSS
      to={{
        pathname: `${order.id}`,
        state: { from: "invoices" }
      }}
    >
      <OrderIdSS>{order.id}</OrderIdSS>

      <OrderPeriodSS>{date}</OrderPeriodSS>

      <OrderStatusSS>
        {intl.formatMessage({ id: `order_status.${order.status}` })}
      </OrderStatusSS>

      <OrderTotalSS>
        <OrderTotalLabelSS>
          {intl.formatMessage({ id: "total" })}
        </OrderTotalLabelSS>
        {formatAsCurrency(order.total, order.currency)}
      </OrderTotalSS>
      <ViewLinkSS
        to={{
          pathname: `./${order.id}`,
          state: { from: "invoices" }
        }}
      >
        View
      </ViewLinkSS>
    </ContainerSS>
  );
};

OrderItem.propTypes = {
  order: PropTypes.object.isRequired
};

export default OrderItem;
